import { usePendingCount } from '../../data/hooks';
import { Badge } from '../../ui';

/**
 * The live count of proposals waiting for a decision (INV-10).
 *
 * Rendered in both navigations, so it lives in its own component with its own query - the
 * TanStack cache dedupes the request, and the SSE `pending` notice invalidates the key,
 * which is what makes the number move without a poll.
 *
 * Nothing is rendered at zero. A badge showing "0" is noise that trains people to ignore
 * the badge.
 */
export function PendingBadge() {
  const count = usePendingCount();
  const pending = count.data ?? 0;
  if (pending === 0) return null;
  return (
    <Badge tone="accent" className="tabular-nums" aria-label={`${pending} waiting for approval`}>
      {pending}
    </Badge>
  );
}
